// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkout_checkout__x82Tf {
  margin-top: 6rem;
  width: 35rem;
  flex-shrink: 0;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 0.8rem;
  padding-block: 2rem;
}

.Checkout_checkout__header__hiNBF {
  color: var(--primary-color);
  font-size: var(--text-2xl);
  font-weight: 700;
  padding-inline-start: 2rem;
  margin-bottom: 3rem;
}

.Checkout_checkout__content-wrapper__TL8xM {
  padding-inline: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.Checkout_checkout__content-row__mQ3Wi {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Checkout_checkout__label__q7amE {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.Checkout_checkout__label--total__IDq9a {
  font-size: var(--text-xl);
}

.Checkout_checkout__value__2S-Qm {
  color: var(--black-light);
  font-size: var(--text-xl);
  font-weight: 700;
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}

.Checkout_checkout__value--discount__TSpF1 {
  color: var(--discount);
}

.Checkout_checkout__currency__hXiTK {
  font-size: var(--text-base);
}

.Checkout_checkout__separator__v1NYV {
  margin-block: 4.5rem 3.7rem;
  height: 0.1rem;
  background-color: var(--black-ten-opacity);
}

.Checkout_checkout__btn__0VxxS {
  margin: 5rem auto 0;
  width: 80%;
  padding-block: 1rem;
  justify-content: center;
}

.Checkout_checkout__branches-modal-footer__H2M\\+H {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Checkout_checkout__branches-modal-total-wrapper__Dn7xh {
  display: flex;
  align-items: center;
  gap: 3.5rem;
}

.Checkout_checkout__branches-modal-total-text__9F74r {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.Checkout_checkout__branches-modal-total-value-wrapper__ccvlS {
  display: flex;
  align-items: flex-end;
  gap: 0.8rem;
  color: var(--black-light);
  font-weight: 700;
}

.Checkout_checkout__branches-modal-total-value__5UIeF {
  font-size: var(--text-xl);
}

.Checkout_checkout__branches-modal-total-currency__h-RCR {
  font-size: var(--text-base);
}

.Checkout_checkout__branches-modal-submit-btn__RdQLw {
  padding: 1rem 4rem;
}

.Checkout_checkout__branches-modal-submit-error__HjB5s {
  margin-top: 1rem;
}

.Checkout_checkout__branches-modal-submit-loading__DkI38 {
  margin-inline: auto;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .Checkout_checkout__x82Tf {
    width: 30rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Cart/Checkout/Checkout.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".checkout {\n  margin-top: 6rem;\n  width: 35rem;\n  flex-shrink: 0;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 0.8rem;\n  padding-block: 2rem;\n}\n\n.checkout__header {\n  color: var(--primary-color);\n  font-size: var(--text-2xl);\n  font-weight: 700;\n  padding-inline-start: 2rem;\n  margin-bottom: 3rem;\n}\n\n.checkout__content-wrapper {\n  padding-inline: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.checkout__content-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.checkout__label {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.checkout__label--total {\n  font-size: var(--text-xl);\n}\n\n.checkout__value {\n  color: var(--black-light);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  display: flex;\n  align-items: flex-end;\n  gap: 0.5rem;\n}\n\n.checkout__value--discount {\n  color: var(--discount);\n}\n\n.checkout__currency {\n  font-size: var(--text-base);\n}\n\n.checkout__separator {\n  margin-block: 4.5rem 3.7rem;\n  height: 0.1rem;\n  background-color: var(--black-ten-opacity);\n}\n\n.checkout__btn {\n  margin: 5rem auto 0;\n  width: 80%;\n  padding-block: 1rem;\n  justify-content: center;\n}\n\n.checkout__branches-modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.checkout__branches-modal-total-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 3.5rem;\n}\n\n.checkout__branches-modal-total-text {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.checkout__branches-modal-total-value-wrapper {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.8rem;\n  color: var(--black-light);\n  font-weight: 700;\n}\n\n.checkout__branches-modal-total-value {\n  font-size: var(--text-xl);\n}\n\n.checkout__branches-modal-total-currency {\n  font-size: var(--text-base);\n}\n\n.checkout__branches-modal-submit-btn {\n  padding: 1rem 4rem;\n}\n\n.checkout__branches-modal-submit-error {\n  margin-top: 1rem;\n}\n\n.checkout__branches-modal-submit-loading {\n  margin-inline: auto;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .checkout {\n    width: 30rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkout": `Checkout_checkout__x82Tf`,
	"checkout__header": `Checkout_checkout__header__hiNBF`,
	"checkout__content-wrapper": `Checkout_checkout__content-wrapper__TL8xM`,
	"checkout__content-row": `Checkout_checkout__content-row__mQ3Wi`,
	"checkout__label": `Checkout_checkout__label__q7amE`,
	"checkout__label--total": `Checkout_checkout__label--total__IDq9a`,
	"checkout__value": `Checkout_checkout__value__2S-Qm`,
	"checkout__value--discount": `Checkout_checkout__value--discount__TSpF1`,
	"checkout__currency": `Checkout_checkout__currency__hXiTK`,
	"checkout__separator": `Checkout_checkout__separator__v1NYV`,
	"checkout__btn": `Checkout_checkout__btn__0VxxS`,
	"checkout__branches-modal-footer": `Checkout_checkout__branches-modal-footer__H2M+H`,
	"checkout__branches-modal-total-wrapper": `Checkout_checkout__branches-modal-total-wrapper__Dn7xh`,
	"checkout__branches-modal-total-text": `Checkout_checkout__branches-modal-total-text__9F74r`,
	"checkout__branches-modal-total-value-wrapper": `Checkout_checkout__branches-modal-total-value-wrapper__ccvlS`,
	"checkout__branches-modal-total-value": `Checkout_checkout__branches-modal-total-value__5UIeF`,
	"checkout__branches-modal-total-currency": `Checkout_checkout__branches-modal-total-currency__h-RCR`,
	"checkout__branches-modal-submit-btn": `Checkout_checkout__branches-modal-submit-btn__RdQLw`,
	"checkout__branches-modal-submit-error": `Checkout_checkout__branches-modal-submit-error__HjB5s`,
	"checkout__branches-modal-submit-loading": `Checkout_checkout__branches-modal-submit-loading__DkI38`
};
export default ___CSS_LOADER_EXPORT___;
